// extracted by mini-css-extract-plugin
export default {"pageTitle":"BasicHeaderWirCreateIntervention_pageTitle__MWBnR","wirCaseNumber":"BasicHeaderWirCreateIntervention_wirCaseNumber__Lyjom"};